export const apiEndpoints = {
  baseUrl: 'https://apiunitar.smarterchains.com',
  assessmentMaturity: '/assessmentmaturity',
  testUrl : 'http://185.19.30.43/educateprepare/api'
}